import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Logo } from "./Logo";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullscreenSpinner label="Authenticating…" />;
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (user.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  return <>{children}</>;
}

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <FullscreenSpinner label="Authenticating…" />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) return <Navigate to="/livetv" replace />;
  return <>{children}</>;
}

function FullscreenSpinner({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center gap-4">
      <Logo className="h-16 w-auto" />
      <div className="w-12 h-12 rounded-full border-2 border-muted border-t-accent-gold animate-spin" />
      <p className="text-[12px] font-ui text-text-secondary uppercase tracking-[0.06em]">
        {label}
      </p>
    </div>
  );
}
